export default __webpack_public_path__ + "static/media/logo-light.eb10a527.svg";